import R from 'ramda';
import { combineReducers } from 'redux';
import { STATE_NAME } from '../constants';

import entities, * as entitiesSelectors from './entities';
import searchCategories, * as searchCategoriesSelectors from './searchCategories';
import loadState, * as loadStateSelectors from './loadState';

export default combineReducers({
  entities,
  searchCategories,
  loadState,
});

const getState = R.prop(STATE_NAME);
const getEntities = R.pipe(
  getState,
  R.prop('entities'),
);
const getLocalizedKinds = R.pipe(
  getState,
  R.prop('searchCategories'),
);
const getLoadState = R.pipe(
  getState,
  R.prop('loadState'),
);

// entitiesSelectors
export const getFeaturedCities = R.pipe(
  getEntities,
  entitiesSelectors.getEntities,
);

// loadStateSelectors
export const getIsLoaded = R.pipe(
  getLoadState,
  loadStateSelectors.getIsLoaded,
);

export const getLocalizedApartmentSlug = R.pipe(
  getLocalizedKinds,
  searchCategoriesSelectors.getLocalizedApartmentSlug,
);
export const getLocalizedRoomSlug = R.pipe(
  getLocalizedKinds,
  searchCategoriesSelectors.getLocalizedRoomSlug,
);
